import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Selections } from './models';
import { QuestionType } from 'store/modules/Quesionnare/types';
import { Button, Loader } from 'components/Base';
import Icons from 'components/Icons';
import { compose } from 'ramda';
import { getFormValues } from 'redux-form';
import Store from '../../store/store';
import Warning from 'components/Charts/Utils/Warning';

const { connect } = Store;

const useStyles = makeStyles(theme => ({
  reviewContainer: {
    overflowY: 'auto',
    height: '100%'
  },
  questionCard: {
    padding: '4px 1rem',
    border: '1px solid #F0F0F0',
    borderRadius: '25px',
    marginBottom: '4px'
  },
  answerCard: {
    padding: '4px 1rem',
    border: '1px solid #F0F0F0',
    backgroundColor: '#F0F0F0',
    borderRadius: '25px',
    marginBottom: '4px'
  },
  successContainer: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center'
  },
  successIcon: {
    height: '100px',
    width: '100px'
  },
  reviewDiv: {
    animation: `$myEffect 1000ms ${theme.transitions.easing.easeInOut}`
  },
  '@keyframes myEffect': {
    '0%': {
      opacity: 0
    },
    '100%': {
      opacity: 1
    }
  },
  buttonContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: '12px'
  }
}));

interface ReviewAnswersProps {
  surveyData: QuestionType[];
  selections: Selections;
  handleSubmit: Function;
  edit: Function;
  userEmail: string;
  submitted: boolean;
  isSubmitting: boolean;
  successful: boolean;
  organization: string;
  values: Record<string, any>;
  showButtons?: boolean;
  Result?: any;
}

const ReviewAnswers = ({
  surveyData,
  selections,
  handleSubmit,
  edit,
  submitted,
  isSubmitting,
  successful,
  organization,
  values,
  showButtons = true,
  Result = null
}: ReviewAnswersProps) => {
  const classes = useStyles();
  const isValid = surveyData.length === Object.keys(selections).length;

  const submit = () => {
    handleSubmit();
  };

  return (
    <div className={classes.reviewDiv}>
      {!submitted && !isSubmitting ? (
        <React.Fragment>
          {isValid ? (
            <>
              <Typography
                component="h1"
                style={{ fontWeight: 600, marginBottom: '24px' }}
              >
                Review Answers
              </Typography>
              <div className={classes.reviewContainer}>
                {surveyData.map((question: QuestionType, i) => {
                  return (
                    <div key={`question_${i + 1}`}>
                      <div className={classes.questionCard}>
                        <Typography component="h2" style={{ fontWeight: 600 }}>
                          {`Q${i + 1}: ` +
                            question.text +
                            (question.label
                              ? `${question.joiner}${question.label}`
                              : '')}
                        </Typography>
                        {question.image_url && (
                          <img
                            src={question.image_url}
                            style={{ width: '100%', maxWidth: '600px' }}
                          />
                        )}
                      </div>
                      <div className={classes.answerCard}>
                        <Typography component="h2">
                          {'A: ' +
                            selections[`Q${i + 1}`].text +
                            (selections[`Q${i + 1}`].details
                              ? `, ${selections[`Q${i + 1}`].details}`
                              : '')}
                        </Typography>
                      </div>
                    </div>
                  );
                })}

                <div style={{ marginTop: '24px' }}>{Result}</div>
              </div>
            </>
          ) : (
            <div>
              <Warning
                text={
                  'This questionnaire is missing some required information. Please restart and fill out again or send it to your client for completion.'
                }
              />
            </div>
          )}
          {showButtons && (
            <div className={classes.buttonContainer}>
              <Button color="primary" type="submit" onClick={() => edit()}>
                Restart
              </Button>
              {values && (
                <Button type="submit" onClick={() => submit()}>
                  Confirm
                </Button>
              )}
            </div>
          )}
        </React.Fragment>
      ) : (
        <div className={classes.successContainer}>
          <Loader isLoading={isSubmitting}>
            {successful ? (
              <>
                <Typography
                  component="h2"
                  style={{ fontWeight: 600, marginBottom: '36px' }}
                >
                  Your attitude to risk score has been calculated and sent to{' '}
                  {organization}
                </Typography>
                <Icons.Success />
              </>
            ) : (
              <Typography
                component="h2"
                style={{ fontWeight: 600, marginBottom: '36px' }}
              >
                Your request to submit your attitude to risk questionnaire was
                unsucessful, please try again later.
              </Typography>
            )}
          </Loader>
        </div>
      )}
    </div>
  );
};
export default compose(
  connect((state: any) => ({
    values: getFormValues('questionaire')(state)
  }))
)(ReviewAnswers);
